import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectUltimateLoad } from "../../../../store/slices/fhwaSlice";

function UltimateLoad() {
  const { t } = useTranslation("fhwa");

  const areaOfGrout = useSelector(selectUltimateLoad);

  const metricUnit = <KiloNewton />;
  const imperialUnit = <Kilopound />;

  return (
    <RowBody
      titleValue={<p>{t("UltimateLoad")}</p>}
      inputValue={
        <span className="input">
          <NumberFormatText value={areaOfGrout.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={metricUnit} Imperial={imperialUnit} />}
    />
  );
}

export default UltimateLoad;
